<mat-card>
  <app-blocks-workflow [blocks]="blocks" [models]="[model]" [context]="context" (workflowComplete)="onWorkflowComplete($event)"></app-blocks-workflow>
</mat-card>
